import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let NotFound = class NotFound extends Vue {
    get notFoundSrc() {
        return `${S3_ASSETS_BUCKET_URL}/not-found.png`;
    }
    goHome() {
        this.$router.push('/');
    }
};
NotFound = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], NotFound);
export default NotFound;
